import { numberToPrettyString } from '@cian/utils';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { setFieldsState } from '../../../actions/fieldsState';
import { FormField } from '../../../components/FormField';
import { PriceInput } from '../../../components/PriceInput';
import { selectDistrictAveragePrice, selectDistrictAveragePriceLocal } from '../../../selectors/district';
import { selectFlatPrice } from '../../../selectors/flatPrice';
import { TThunkDispatch } from '../../../types/redux/thunk';

interface IFlatPriceProps {
  isGeoSuggestEnabled: boolean;
}

export const FlatPrice: React.FC<IFlatPriceProps> = ({ isGeoSuggestEnabled }: IFlatPriceProps) => {
  const dispatch = useDispatch<TThunkDispatch>();

  const averagePrice = useSelector(isGeoSuggestEnabled ? selectDistrictAveragePrice : selectDistrictAveragePriceLocal);
  const flatPrice = useSelector(selectFlatPrice);

  const fieldDescription =
    averagePrice != null ? `${numberToPrettyString(averagePrice)}\u0020₽ — средняя цена в этом районе` : '';

  const handleChange = React.useCallback(
    (value: number) => {
      dispatch(setFieldsState({ flatPrice: value, flatPriceChanged: true }));
    },
    [dispatch],
  );

  return (
    <FormField label="Сколько стоит?" description={fieldDescription} data-name="FlatPriceFormField">
      <PriceInput value={flatPrice} onChange={handleChange} />
    </FormField>
  );
};
